import { string } from 'fp-ts';
import { Optional } from '@mews/std';
import { utcToLocalizedDate } from '@mews-commander/utils';

export const utcLocalizedDate = (date: Optional<string>, timezone: string) =>
    string.isString(date) ? utcToLocalizedDate(date, timezone) : null;
